// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1QrMv","title":"Info_title__WyMgb","links":"Info_links__3bBt0","link":"Info_link__1aAqc","logo":"Info_logo__3oI9s"};